export default __webpack_public_path__ + "static/media/brain.5a40cb37.png";